import { render } from "./coupon.vue?vue&type=template&id=0e28bb81&scoped=true&ts=true"
import script from "./coupon.vue?vue&type=script&lang=ts"
export * from "./coupon.vue?vue&type=script&lang=ts"

import "./coupon.vue?vue&type=style&index=0&id=0e28bb81&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e28bb81"]])

export default __exports__